import type { TypographyOptions } from '@mui/material/styles/createTypography';

export const typographyFigmaThemeConfig: TypographyOptions = {
  fontSize: 16,
  fontFamily: 'Roboto, sans-serif',
  htmlFontSize: 10,

  body1: {
    fontSize: '16px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: '#666666',
    lineHeight: '150%',
    letterSpacing: '0.15px',
  },
  body2: {
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: '#666666',
    lineHeight: '143%',
    letterSpacing: '0.17px',
  },
  subtitle1: {
    fontSize: '16px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: '#666666',
    lineHeight: '175%',
    letterSpacing: '0.15px',
  },
  subtitle2: {
    fontSize: '14px',
    fontWeight: 500,
    fontStyle: 'normal',
    color: '#666666',
    lineHeight: '157%',
    letterSpacing: '0.1px',
  },
  overline: {
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: '#666666',
    lineHeight: '266%',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  caption: {
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: '#666666',
    lineHeight: '150%',
    letterSpacing: '0.15px',
  },
  h1: {
    fontSize: '96px',
    fontWeight: 300,
    fontStyle: 'normal',
    color: '#333333',
    lineHeight: '116.7%',
    letterSpacing: '-1.5px',
  },
  h2: {
    fontSize: '60px',
    fontWeight: 300,
    fontStyle: 'normal',
    color: '#333333',
    lineHeight: '120%',
    letterSpacing: '-0.5px',
  },
  h3: {
    fontSize: '48px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: '#333333',
    lineHeight: '116.7%',
  },
  h4: {
    fontSize: '34px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: '#333333',
    lineHeight: '123.5%',
    letterSpacing: '0.25px',
  },
  h5: {
    fontSize: '24px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: '#333333',
    lineHeight: '133.4%',
  },
  h6: {
    fontSize: '20px',
    fontWeight: 500,
    fontStyle: 'normal',
    color: '#333333',
    lineHeight: '160%',
    letterSpacing: '0.15px',
  },
};
